import TestPage from '../components/TestPage';

export default function Test() {
  return <TestPage/>;
}